import React, {Fragment, memo} from 'react';
import {useSelector} from 'react-redux';
import {viewSelector} from '@mapsight/ui/src/js/store/selectors';

import {VIEW_DESKTOP, VIEW_MOBILE} from '@mapsight/ui/src/js/config/constants/app';

import ZoomButtons from '@mapsight/ui/src/js/components/map-overlay/zoom-buttons';
import UserGeoLocationButton from '@mapsight/ui/src/js/components/map-overlay/user-geo-location-button';

import {memoForever} from '../../modules/helpers';

// Hinweis: UserGeoLocationButton ist nur sichtbar wenn https:// da nur dann die Position abgefragt werden kann
/** @type {import("@mapsight/ui/src/js/components/contexts").MapOverlayTopRight} */
const MapOverlayTopRight = memo(function MapOverlayTopRight({}) {
		const view = useSelector(viewSelector);

		if (view === VIEW_MOBILE || view === VIEW_DESKTOP)
			return null;

		return (
			<Fragment>
				<UserGeoLocationButton/>
				<ZoomButtons/>
			</Fragment>
		);
	},
	memoForever
);

export default MapOverlayTopRight;
